import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-row grow items-stretch py-1"
};
const _hoisted_2 = {
  class: "grow pl-2 flex justify-center items-center text-slate-600"
};
const _hoisted_3 = {
  class: "flex-center flex-col"
};
const _hoisted_4 = {
  class: "flex-center mr-2"
};
const _hoisted_5 = {
  class: "flex flex-col grow"
};
const _hoisted_6 = {
  class: "flex items-center"
};
const _hoisted_7 = {
  class: "font-bold"
};
const _hoisted_8 = {
  class: "flex items-center"
};
const _hoisted_9 = {
  class: "flex items-stretch px-1 child:mx-0.5"
};
import { app } from "@/di";
import Flag from "@/modules/vue/components/Flag.vue";
import ActionPointDisplay from "@/modules/team/components/ActionPointDisplay.vue";
import { Season } from "@/modules/season/entity";
import { Team } from "@/modules/team/entity";
import { EventEmitter } from "@/modules/base/events";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
import Icon from "@/modules/vue/components/Icon.vue";
import ExchangeActionSheet from "@/modules/action-points/components/ExchangeActionSheet.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
import TeamLogo from "@/modules/team/components/TeamLogo.vue";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
export default /*#__PURE__*/_defineComponent({
  __name: 'InGameActionBar',
  async setup(__props) {
    let __temp, __restore;
    const season = ref();
    const team = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      season.value = await Season.current();
      team.value = await Team.createQueryBuilder('team').innerJoinAndSelect('team.country', 'country').where('team.user = true').getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    const gateType = ref();
    const exchangeActionSheet = ref(null);
    const onClickActionPoints = clickedGateType => {
      gateType.value = clickedGateType;
      nextTick(() => {
        exchangeActionSheet.value.show();
      });
    };
    const router = useRouter();
    const onClickCoins = () => {
      if (!app.get(ConfigRepository).get('coins.enabled')) {
        return;
      }
      router.push({
        name: 'action-points.buy-coins'
      });
    };
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterDayEvaluationEvent, AfterCurrencyChangeEvent], refresh));
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(Flag, {
        country: team.value.country,
        class: "mr-2"
      }, null, 8, ["country"]), _createElementVNode("div", _hoisted_4, [_createVNode(TeamLogo, {
        team: team.value,
        class: "h-8 w-8"
      }, null, 8, ["team"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(team.value.shortName), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(Icon, {
        icon: _ctx.IconEnum.ClockRegular,
        size: "1rem",
        class: "mr-1"
      }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$date(season.value.currentDate)), 1)])])]), _createElementVNode("div", _hoisted_9, [_createVNode(ActionPointDisplay, {
        icon: _ctx.IconEnum.EuroFilled,
        color: _ctx.ColorEnum.Green,
        onClick: _cache[0] || (_cache[0] = $event => onClickActionPoints(_unref(GateTypeEnum).BALANCE))
      }, {
        value: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(team.value.balance)), 1)]),
        _: 1
      }, 8, ["icon", "color"]), _createVNode(ActionPointDisplay, {
        value: team.value.actionPointsTraining,
        icon: _ctx.IconEnum.Dumbbell,
        color: _ctx.ColorEnum.Red,
        onClick: _cache[1] || (_cache[1] = $event => onClickActionPoints(_unref(GateTypeEnum).TRAINING_AT))
      }, null, 8, ["value", "icon", "color"]), _createVNode(ActionPointDisplay, {
        value: team.value.actionPointsNegotiating,
        icon: _ctx.IconEnum.Handshake20Regular,
        color: _ctx.ColorEnum.Fuchsia,
        onClick: _cache[2] || (_cache[2] = $event => onClickActionPoints(_unref(GateTypeEnum).NEGOTIATION))
      }, null, 8, ["value", "icon", "color"]), _createVNode(ActionPointDisplay, {
        value: team.value.actionPointsScouting,
        icon: _ctx.IconEnum.Binoculars,
        color: _ctx.ColorEnum.Sky,
        onClick: _cache[3] || (_cache[3] = $event => onClickActionPoints(_unref(GateTypeEnum).SCOUTING))
      }, null, 8, ["value", "icon", "color"]), _createVNode(ActionPointDisplay, {
        value: team.value.actionPointsCoins,
        icon: _ctx.IconEnum.Coins,
        color: _ctx.ColorEnum.Gold,
        onClick: onClickCoins
      }, null, 8, ["value", "icon", "color"]), _createVNode(_component_NButton, {
        size: "small",
        secondary: "",
        class: "px-1 self-stretch h-full",
        onClick: _cache[4] || (_cache[4] = () => _ctx.$router.push({
          name: 'action-points.exchange'
        }))
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.IosCog
        }, null, 8, ["icon"])]),
        _: 1
      }), _createVNode(ExchangeActionSheet, {
        ref_key: "exchangeActionSheet",
        ref: exchangeActionSheet,
        type: gateType.value
      }, null, 8, ["type"])])]);
    };
  }
});